




















































import {Component, Vue} from 'vue-property-decorator';
import {httpClient} from '@/api/baseApi';
import Breadcrumbs from '@c/controls/Breadcrumbs.vue';
import BearingJournal from '@/views/system/nodes/BearingJournal.vue';
import StateMonitor from '@/views/system/nodes/StateMonitor.vue';
import PModuleCard from '@/views/system/nodes/PModuleCard.vue';
import DtcpAccelerometerPModuleCard from '@/views/system/nodes/DtcpAccelerometerPModuleCard.vue';
import Loading from '@c/controls/Loading.vue';
import {PModulePosition, PModuleWithCoords} from '@/views/system/modules/interfaces';
import {NodeData} from '@/system/nodes/interfaces';
import nodeModule from '@/store/modules/entities/nodeModule';

@Component({
  components: {
    Breadcrumbs,
    BearingJournal,
    StateMonitor,
    PModuleCard,
    DtcpAccelerometerPModuleCard,
    Loading,
  },
})
export default class NodeSensorsView extends Vue {
  loadingTree = false;
  errorTree = false;
  loading = false;
  error = false;

  // Выбранный путь в дереве структуры предприятия
  nodesPath: NodeData[] = [];

  items: NodeData[] = [];
  bearingtasks: any[] = [];

  basePModulesList: PModuleWithCoords[] = [];

  get nodeData() {
    const nodeId = Number(this.$route.params.id);
    const existingNode = this.basePModulesList.filter(
      (item: PModuleWithCoords) =>
        item.guid &&
        item.coords &&
        item.nodes &&
        item.nodes.filter((pos: PModulePosition) => pos.node_id == nodeId).length > 0,
    );
    return [...existingNode];
  }

  async mounted() {
    const nodeId = Number(this.$route.params.id);
    try {
      this.loading = true;
      this.error = false;
      await nodeModule.fetchAll();
      this.basePModulesList = await nodeModule.getModules(nodeId);
    } catch {
      this.error = true;
    } finally {
      this.loading = false;
    }
  }

  async created() {
    this.loading = true;
    const nodeId = Number(this.$route.params.id);
    await this.loadTree();
    this.nodesPath = this.getPathByNodeId(nodeId);
    const {data} = await httpClient.get<[]>(`nodes_rel/${nodeId}/bearing-tasks/`);
    if (data) this.bearingtasks = data;
    this.loading = false;
  }

  getPathByNodeId(id: number): NodeData[] {
    const stack = [...this.items];
    const prev: Record<string, NodeData> = {};
    while (stack.length) {
      const x = stack.pop();
      if (x && x.id == id) {
        const path: NodeData[] = [];
        let node = x;
        path.push(node);
        while (prev[node.id ? node.id : 0]) {
          node = prev[node.id ? node.id : 0];
          path.push(node);
        }
        path.reverse();
        return path;
      }
      if (x && x.children)
        x.children.forEach(c => {
          if (c.id) {
            prev[c.id] = x;
            stack.push(c);
          }
        });
    }
    return [];
  }

  checkCorrectLevelNode = (parentType: number, node: NodeData) => node.type < parentType;

  checkChildren = (item: NodeData) => {
    if (item.children && item.children.length) {
      item.children.forEach(node => {
        if (item.children && item.children.length) {
          if (this.checkCorrectLevelNode(item.type, node)) {
            node.leveTypeError = true;
          }
          //          node.parent = {name: item.name, type: item.type};
          this.checkChildren(node);
        }
        return;
      });
    }
  };

  // Загрузка дерева
  async loadTree() {
    await nodeModule.fetchAll();
    try {
      this.loadingTree = true;
      const temp = [...nodeModule.all];
      temp.forEach(item => {
        this.checkChildren(item);
      });
      this.items = temp;
    } catch {
      this.errorTree = true;
    } finally {
      this.loadingTree = false;
    }
  }

  onChangeNode(item: NodeData) {
    this.$router.push({path: `/nodes/${item.id}`}).catch(() => {
      return 0;
    });
  }
}
